module.exports = __webpack_public_path__ + "media/2_ring_in.3ba9cc9c.mp3";